// Real Results From Our Portfolio: turns the case-study card grid into a
// Swiper slider with prev/next arrows, a "1/3" counter, and mobile dots.

const ARROW_SVG =
  '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
  '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" ' +
  'stroke-linecap="round" stroke-linejoin="round"/></svg>';

function makeArrow(kind, label) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'kd-pr__arrow kd-pr__arrow--' + kind;
  btn.setAttribute('aria-label', label);
  btn.innerHTML = ARROW_SVG;
  return btn;
}

export default function initPortfolioResults() {
  const sections = document.querySelectorAll('.kd-pr');
  if (!sections.length) return;

  sections.forEach((section) => {
    const grid = section.querySelector('.kd-pr-grid');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('.kd-pr-card'));
    if (!cards.length) return;

    // --- Build the Swiper structure, reusing the existing card nodes -------
    const sliderEl = document.createElement('div');
    sliderEl.className = 'kd-pr__slider swiper';

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    cards.forEach((c) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(c);
      wrapper.appendChild(slide);
    });
    sliderEl.appendChild(wrapper);

    // --- Controls: arrows + "1/3" counter (desktop) ------------------------
    const controls = document.createElement('div');
    controls.className = 'kd-pr__controls';

    const arrows = document.createElement('div');
    arrows.className = 'kd-pr__arrows';
    const prevBtn = makeArrow('prev', 'Previous case study');
    const nextBtn = makeArrow('next', 'Next case study');
    arrows.appendChild(prevBtn);
    arrows.appendChild(nextBtn);

    const counter = document.createElement('div');
    counter.className = 'kd-pr__counter';

    function setCounter(current, total) {
      const t = total || cards.length;
      const n = Math.min(Math.max(current, 1), t);
      counter.innerHTML =
        '<span class="kd-pr__counter-current">' +
        String(n) +
        '</span><span class="kd-pr__counter-sep">/</span>' +
        '<span class="kd-pr__counter-total">' +
        String(t) +
        '</span>';
    }

    // With wide "auto" slides the last snap can leave activeIndex unchanged, so
    // drive the counter off snapIndex / snapGrid instead.
    function updateCounter(sw) {
      const total = (sw.snapGrid && sw.snapGrid.length) || cards.length;
      setCounter((sw.snapIndex || 0) + 1, total);
    }

    setCounter(1, cards.length);

    controls.appendChild(arrows);
    controls.appendChild(counter);

    // --- Mobile dots -------------------------------------------------------
    const dots = document.createElement('div');
    dots.className = 'kd-pr__dots swiper-pagination';

    // --- Swap the plain grid for controls + slider + dots ------------------
    grid.replaceWith(controls, sliderEl, dots);

    if (!window.Swiper) return;

    /* eslint-disable no-new */
    const swiper = new window.Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      grabCursor: true,
      watchOverflow: true,
      navigation: { prevEl: prevBtn, nextEl: nextBtn },
      pagination: { el: dots, clickable: true },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 16 },
        769: { slidesPerView: 'auto', spaceBetween: 30 },
      },
      on: {
        init() {
          updateCounter(this);
        },
        snapIndexChange() {
          updateCounter(this);
        },
        slideChange() {
          updateCounter(this);
        },
        snapGridLengthChange() {
          updateCounter(this);
        },
        resize() {
          updateCounter(this);
        },
      },
    });

    // `init` fires before our handler is attached on some Swiper builds — sync.
    updateCounter(swiper);
  });
}
